module.exports = __webpack_public_path__ + "static/media/onePlanIcon.df173951.svg";